import { DOCUMNENT_FETCHING, DOCUMNENT_FAILED, DOCUMNENT_SUCCESS, server } from '../../constants'
import backendEndpoint from '../../api/etrBackend'
import httpClient from '../../api/httpClient'
import { setError } from './error.action'
import { RootReducers } from '../reducers'

export const setDocumentFetchingToState = () => ({
  type: DOCUMNENT_FETCHING
})

export const setDocumentSuccessToState = (payload: any) => ({
  type: DOCUMNENT_SUCCESS,
  payload
})

export const setDocumentFailedToState = (payload: any) => ({
  type: DOCUMNENT_FAILED,
  payload
})

export const handleGetDocument = (ref: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setDocumentFetchingToState())
      const result = await backendEndpoint.get(`${server.DOWNLOAD_DOCUMENT_URL}/${ref}`)
      if (result.data.result === 'SUCCESS') {
        dispatch(setDocumentSuccessToState(result.data))
      } else {
        dispatch(setDocumentFailedToState(result.data))
      }
    } catch (error) {
      const data = {
        result: 'FAILED',
        message: 'ระบบไม่สามารถทำการ Download เอกสารได้'
      }
      dispatch(setDocumentFailedToState(data))
    }
  }
}

export const getDocumentUploadFileBlob = (ref: string) => {
  return async (dispatch: any) => {
    try {
      const res = await httpClient.get(server.RECEIPT + '/upload/' + btoa(ref), {
        responseType: 'blob'
      })

      return res
    } catch (error) {
      dispatch(setError(error))
    }
  }
}

export const deleteChangeEmailOrMobileFile = (ref: string) => {
  return async (dispatch: any) => {
    try {
      const res = await httpClient.delete(
        server.TRANSACTION_URL + '/deleteChangeEmailOrMobileFile/' + btoa(ref)
      )

      return res
    } catch (error) {
      dispatch(setError(error))
    }
  }
}

export const getDocumentAging = () => {
  return async (dispatch: any, getState: () => RootReducers) => {
    const agentId = getState().loginReducer.account?.agentInfo?.agentId

    try {
      if (!agentId) {
        throw new Error('Can not find agentId')
      }

      const res = await httpClient.get(
        server.TRANSACTION_URL + '/getDocumentAging/' + btoa(agentId)
      )

      return res.data
    } catch (error) {
      dispatch(setError(error))
    }
  }
}
